import ConditionalRule from "../conditionalRules/conditionalRule";
import IRepo from "../../interfaces/repo";
import Repo from "../../state/modules/repo";
import ObjectModelProperty from "../objectModelProperties/objectModelProperty";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";

// conditional rules used in the object model builder aren't just utitilizing properties anymore... they're also using account relations (and maybe more in the future)
export default class ObjectModelConditionalRule extends ConditionalRule {
  static repo: IRepo<ObjectModelConditionalRule> = new Repo('conditionalRules', ObjectModelConditionalRule);

  get referencedControl(): ObjectModelProperty | ObjectModelRelation {
    return ObjectModelProperty.repo.find(this.referenced_control_id) || ObjectModelRelation.repo.find(this.referenced_control_id);
  }

  getValueString(id: string): string {
    const element = ObjectModelProperty.repo.find(id) ||  ObjectModelRelation.repo.find(id);
    return element ? element.label_title : '';
  }
}